import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { TimePeriod } from '../../../../design/selects/timePeriodSelector/S_TimePeriodSelector';
import { ITeamService } from '../team.bl';
import { ITeamStore } from '../team.store';
import { StatisticsTimeFrameSwitch } from './StatisticsTimeFrameSwitch';

export const StatisticsTimeFrameSwitchContainer = observer((): ReactElement => {
  const teamStore = useInjection(ITeamStore.$);
  const teamService = useInjection(ITeamService.$);

  const handleTimePeriodChange = async (timePeriod: TimePeriod): Promise<void> => {
    await teamService.changeStatisticsTimePeriodAsync(timePeriod);
  };

  const { statisticsTimePeriod } = teamStore;
  return (
    <StatisticsTimeFrameSwitch
      onPeriodChange={handleTimePeriodChange}
      selectedTimePeriod={statisticsTimePeriod}
    />
  );
});
